import { publicUrlFor } from "../constants";

function FastImage(props) {
    return (
        <>
            <img {...props} 
             alt={props.alt} />
        </>
    )
}
export default FastImage;